import { render, staticRenderFns } from "./StoreTransferCreateConfirmation.vue?vue&type=template&id=5db74402"
import script from "./StoreTransferCreateConfirmation.vue?vue&type=script&lang=js"
export * from "./StoreTransferCreateConfirmation.vue?vue&type=script&lang=js"
import style0 from "./StoreTransferCreateConfirmation.vue?vue&type=style&index=0&id=5db74402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports